<app-loader class="text-muted" i18n>Loading...</app-loader>
